<!-- 구단별 // 입장수입 현황 -->
<template>
  <div div class="report-tit"> 
    <p>구단별 입장수입 현황</p>
    <p class="term">( {{this.common.yyyyMMddDot($store.state.refer.firstSelectDate)}} 현재 )</p>
    <span class="txt-r">Date : {{this.common.yyyyMMddDot(this.common.DateObjToString(new Date()))}}</span>
  </div>
  <table class="tb-data">
    <colgroup>
      <col width="116px">
      <col width="55px">
      <col width="95px">
      <col width="115px">
      <col width="55px">
      <col width="95px">
      <col width="95px">
      <col width="55px">
      <col width="115px">
      <col width="115px">
      <col width="55px">
    </colgroup>
    <tr>
      <th rowspan="2">구단</th>
      <th colspan="3">{{parseInt(this.common.yyyyMMddDot($store.state.refer.firstSelectDate).substring(0, 4)) - 1 + '년'}}</th>
      <th colspan="7">{{parseInt(this.common.yyyyMMddDot($store.state.refer.firstSelectDate).substring(0, 4)) + '년'}}</th>
      <th colspan="2">평균인원</th>
    </tr>
    <tr>
      <th class="border">경기수</th>
      <th>인원</th>
      <th>금액</th>
      <th>경기수</th>
      <th>당일인원</th>
      <th>누적인원</th>
      <th>증감(%)</th>
      <th>당일금액</th>
      <th>누적금액</th>
      <th>증감(%)</th>
      <th>{{parseInt(this.common.yyyyMMddDot($store.state.refer.firstSelectDate).substring(0, 4)) - 1 + '년'}}</th>
      <th>{{parseInt(this.common.yyyyMMddDot($store.state.refer.firstSelectDate).substring(0, 4)) + '년'}}</th>
    </tr>
    <tr v-for="(item, index) in items" :key="index">
      <td class="txt-c">{{ getTeamFullName(item.tId) }}</td>
      <td>{{ item.pastTotalGCn }}</td>
      <td>{{ item.pastCrowdCn }}</td>
      <td>{{ item.pastCrowdMo }}</td>
      <td>{{ item.nowTotalGCn }}</td>
      <td>{{ item.dailyCrowdCn }}</td>
      <td>{{ item.nowCrowdCn }}</td>
      <td>{{ item.crowdCnRt }}</td>
      <td>{{ item.dailyCrowdMo }}</td>
      <td>{{ item.nowCrowdMo }}</td>
      <td>{{ item.crowdMoRt }}</td>
      <td>{{ item.pastAvgCn }}</td>
      <td>{{ item.nowAvgCn }}</td>
    </tr>
    <tr v-if="itemsResult" class="total">
      <td class="txt-c"><b>합계</b></td>
      <td>{{ itemsResult.pastTotalGCn }}</td>
      <td>{{ itemsResult.pastCrowdCn }}</td>
      <td>{{ itemsResult.pastCrowdMo }}</td>
      <td>{{ itemsResult.nowTotalGCn }}</td>
      <td>{{ itemsResult.dailyCrowdCn }}</td>
      <td>{{ itemsResult.nowCrowdCn }}</td>
      <td>{{ itemsResult.crowdCnRt }}</td>
      <td>{{ itemsResult.dailyCrowdMo }}</td>
      <td>{{ itemsResult.nowCrowdMo }}</td>     
      <td>{{ itemsResult.crowdMoRt }}</td>
      <td>{{ itemsResult.pastAvgCn }}</td>
      <td>{{ itemsResult.nowAvgCn }}</td>
    </tr>
  </table>
</template>
<style scoped src="@/assets/css/print.css"></style>

<script>
import Common from '@/utils/common';

export default{ 
  name:'TeamEntranceIncome',
  components:{},
  data() {
    return{
      sampleData: '',
      common: new Common(),
      items: null,
      itemsResult: null,
    };
  },
  watch:{
    '$store.state.refer.isReload'(){
      this.getTeamEntranceIncome();
    }
  },
  setup() {},
  created() {
    this.$store.dispatch("getTeamList").then((res) => {
      this.$store.commit(
        "setTeamList",
        res.data.teamList.filter(
          (item) => item.season == new Date().getFullYear()
        )
      );
    });
  },
  mounted() {
    this.getTeamEntranceIncome();
  },
  unmounted() {},
  methods: {
    getTeamEntranceIncome() {
            this.$store.dispatch("refer/getTeamEntranceIncome").then(res => {
                    this.items = res.data.value.data.teamAdmissionIncomeList;
                    this.itemsResult = res.data.value.data.sumAdmissionIncomeList;
                });
    },
    getTeamFullName(teamId) {
      const teamArray = this.$store.state.teamList.find(
        (item) => item.teamId == teamId
      );
      return teamArray ? teamArray.teamFullName : "";
    },
  }
}
</script>
